module.exports = __webpack_public_path__ + "images/fa-free-offer-upgrade-mobile-bg.jpg";